import { FC, ReactNode, ComponentProps } from 'react';
import classNames from 'classnames';
import styles from './simple-card.module.scss';
import { Tag } from 'wa-storybook/components/tag/Tag';

// Get the props type from the Tag component
type TagProps = ComponentProps<typeof Tag>;

type Props = {
  children?: ReactNode;
  noShadow?: boolean;
  outline?: boolean;
} & TagProps;

const SimpleCard: FC<Props> = ({
  children,
  className,
  noShadow,
  outline,
  ...rest
}: Props) => {
  return (
    <Tag
      className={classNames(
        styles.card,
        noShadow && styles['card--no-shadow'],
        outline && styles['card--outline'],
        className,
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default SimpleCard;
